<template>
	<div class="report_container full" style="overflow: auto;">
		<div style="position: relative;margin-top: 10px;">
			<el-form ref="form" label-width="60px" size="mini">
				<el-form-item label="仓库" style="width: 300px;">
					<el-select v-model="warehouse" @change="warehouseChange">
						<el-option label="温州仓(WMS)" value="01086F84264C3CA5BC64EE7A095A1372"></el-option>
						<el-option label="佛山仓(WMS)" value="F3A01CA63B7D38E9ADBFF7874630E600"></el-option>
						<el-option label="永年仓(WMS)" value="79ADAC90C4B13D9AA6ECDB2EE9FFB1FB"></el-option>
						<el-option label="气动元件仓" value="3919636A4DD732E3ABF977255DBE934C"></el-option>						
					</el-select>
				</el-form-item>
			</el-form>
			<el-divider content-position="center">今日数量统计</el-divider>
			<statics-index ref="warehousepurchaseStaticsIndex" :warehouse="warehouse" />
		</div>
		<div style="position: relative;margin-top: 30px;">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-divider content-position="center">预计到货</el-divider>
					<el-card class="box-card">
						<arrivedIndex ref="warehousepurchaseArrivedIndex" :warehouse="warehouse" />
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-divider content-position="center">超时未入库</el-divider>
					<el-card class="box-card">
						<overtimeIndex ref="warehousepurchaseOvertimeIndex" :warehouse="warehouse" />
					</el-card>
				</el-col>
			</el-row>

		</div>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import staticsIndex from './lib/statics/index.vue'
	import arrivedIndex from './lib/arrived/index.vue'
	import overtimeIndex from './lib/overtime/index.vue'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {

		},
		data() {
			return {
				outputmerge: [],
				reportName: 'warehousepurchase',
				windowName: '仓库到货统计',
				warehouse:'01086F84264C3CA5BC64EE7A095A1372',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			warehouseChange(e){
				this.warehouse = e
				this.$nextTick(()=>{
					this.$refs.warehousepurchaseStaticsIndex.load()
					this.$refs.warehousepurchaseArrivedIndex.customreload()
					this.$refs.warehousepurchaseOvertimeIndex.customreload()
				})
			}

		},
		components: {
			staticsIndex,
			arrivedIndex,
			overtimeIndex
		}
	}
</script>